import { useEffect, useState } from "react";
import { Offcanvas, Container, Form } from "react-bootstrap";
import api from "../../seller-apis/api";
import { useAlert } from "react-alert";

import variables from '../../Variables.json'
const NewPriceReqPopup = ({ offcanshow, handleCloseoffcan, lowestPrice, currGst, pPrice, lead, url, isCombination, handleCallBackSuccessStatus, receivedFrom }) => {



    let gstOptions = ["", ...variables?.variables?.gstValues];
    const alert = useAlert()
    const [gstPercent, setGstPercent] = useState("");
    const [gstError, setGstError] = useState(false);
    const [price, setPrice] = useState(0);
    const [priceError, setPriceError] = useState(false);

    const handleCloseoffcanFun = () => {
        setGstError("");
        setPriceError("");
        setGstPercent("");
        setPrice(undefined);
        handleCloseoffcan();
    }

    const handleGst = (val) => {
        setGstPercent(val);
    };

    const updateGst = async () => {
        if (gstPercent === currGst) {
            setGstError("Please select different GST percentage");
            return;
        }
        if (gstPercent === "" || gstPercent === null || gstPercent === undefined) {
            setGstError("Please select GST percentage");
            return;
        }
        const res = await api.product.addToExProduct({
            _id: lead,
            taxClass: gstPercent
        })
        if (res.message === "product updated" || res.message === "product added") {
            alert.success("GST updated uccessfully!");
            handleCloseoffcanFun()
            handleCallBackSuccessStatus(true)
        }
        else {
            alert.info("Something went wrong, please try again later");
            handleCloseoffcanFun()
            handleCallBackSuccessStatus(false)
        }
        console.log(res)

    }

    const updatePrice = async () => {
        if (price === 0 || price === null || price === undefined) {
            setPriceError("Please enter a valid price");
            return;
        }
        if (price === pPrice) {
            setPriceError("Please enter different price");
            return;
        }

        // Use the same API pattern as ProductDetail and ProductDetConf
        const data = {
            product: lead,
            price: price,
            receivedFrom:receivedFrom
        };

        // For combination products - add URL (matching ProductDetConf structure)
        if (isCombination) {
            data.url = url;
        }

        const res = await api.transferprice.priceChangeRquest(data);

        if (res.message === "price change request submitted") {
            alert.success("New price request successfully sent to Toolsvilla");
            handleCloseoffcanFun();
            handleCallBackSuccessStatus(true);
        } else {
            handleCallBackSuccessStatus(false);
            alert.info(res.message || "Something went wrong, please try again later");
        }
    }


    return (
        <Offcanvas
            show={offcanshow}
            onHide={() => handleCloseoffcanFun()}
            placement="bottom"
            className="h-40 pd_Offcanvas m-auto "
            backdrop="static"
        >
            <Offcanvas.Header>
                <Offcanvas.Title></Offcanvas.Title>
                <div className="w-100">
                    <button
                        className="pd_my_Modal_close_btn"
                        onClick={() => handleCloseoffcanFun()}
                    >
                        X
                    </button>
                </div>
            </Offcanvas.Header>
            <Offcanvas.Body className="m-0 p-0">
                <Container className="pd_offcanvas_body">
                    <h4 className="text-center">New Price Request</h4>
                    <div className="pd_Offcanvas_Grey_Box">
                        <p className="theme-col f-600 fs-14 row">

                            <span className="col-11 text-center">
                                <span className="text-black">
                                    Current Transfer Price (incl. {currGst}% GST)
                                </span>{" "}
                                :
                                <span className="f-600 ms-1">
                                    {" "}
                                    <i className="fa fa-inr"></i> {pPrice}{" "}
                                </span>
                            </span>
                        </p>
                        {lowestPrice !== undefined ? (
                            <p className="pb-0 f-500 text-center">
                                <span className="pd_other_seller_price text-center">
                                    {" "}
                                    Other seller's price(incl. GST) :{" "}
                                    <i className="fa fa-inr"></i> {lowestPrice}{" "}
                                </span>
                            </p>
                        ) : (
                            <></>
                        )}
                    </div>
                    <div className="pd_Offcanvas_Action">
                        <div className="pd_Offcanvas_Grey_Box">
                            <p className="iscorr_trans_p row">
                                <span className="col-6">

                                    Please Enter New Transfer Price :
                                </span>
                                <i
                                    className="fa fa-inr pd_input_inr"
                                    aria-hidden="true"
                                ></i>
                                <input
                                    className="pd_input_price col-2"
                                    type="number"
                                    onChange={(e) => setPrice(e.target.value)}
                                    onWheel={(e) => e.target.blur()}
                                ></input>
                                <button
                                    className="pd_change_gst_btn col-2"
                                    id="sub_newreq"
                                    onClick={() => updatePrice()}
                                >
                                    SUBMIT
                                </button>
                            </p>
                        </div>
                        <div className="pd_Offcanvas_Grey_Box mt-1">
                            <p className="row">
                                <span className="col-6 my-auto">

                                    GST :{" "}
                                </span>
                                <Form.Select
                                    size="sm"
                                    className="pd_Gst_Options col-2"
                                    value={gstPercent}
                                    onChange={(e) => handleGst(e.target.value)}
                                >
                                    {gstOptions.length > 0 &&
                                        gstOptions.map((item, index) => {
                                            return (
                                                <option key={index} value={item}>
                                                    {item} {item !== "" ? "%" : ""}
                                                </option>
                                            );
                                        })}
                                </Form.Select>{" "}
                                <button
                                    className="pd_change_gst_btn col-2"
                                    onClick={() => updateGst()}
                                >
                                    SUBMIT
                                </button>
                            </p>
                        </div>
                    </div>
                    {priceError && (
                        <p className="text-danger text-center">
                            {priceError} !
                        </p>
                    )}
                    {gstError && (
                        <p className="text-danger text-center">
                            {gstError} !
                        </p>
                    )}
                </Container>
            </Offcanvas.Body>
        </Offcanvas >
    )
}

export default NewPriceReqPopup